<template>
    <div>
        <loading v-if="!tags" />

        <div v-else>
            <div class="list-group w-100">
                <router-link v-for="tag in tags"
                             v-bind:key="tag"
                             class="list-group-item list-group-item-action"
                             :to="{ name: 'documentation-tag-page', params: { tag: `${tag}` } }">{{ tag }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        data() {
            return {
                tags: null
            };
        },
        methods: {
        },

        async created() {
            let response = await this.$http.get("/documentation/tags");
            this.tags = response.data;
        }
    };
</script>

<style>
    .documentation-tag-list-item {
        cursor: pointer;
    }
</style>
